import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { INTELLIGENCE_TABS } from "./intelligenceTabs";
import "./intelligence.css";

/* Tab bar shared by the four Information Intelligence screens. Each screen
   still renders its own header and controls below it. */
const IntelligenceLayout = () => {
  const { t } = useTranslation();

  return (
    <div className="ii-shell">
      <div className="ii-bar">
        <div className="ii-eyebrow">{t("title.Information Intelligence")}</div>
        <nav className="ii-tabs" role="tablist">
          {INTELLIGENCE_TABS.map((tab) => (
            <NavLink
              key={tab.path}
              to={`/${tab.path}`}
              role="tab"
              className={({ isActive }) => (isActive ? "ii-tab is-active" : "ii-tab")}
            >
              {t(`title.${tab.key}`)}
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
};

export default IntelligenceLayout;
